import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'actionMessage'
	| 'pageSelectorLabel'
	| 'titlePlaceholder'
	| 'titleLabel'
	| 'addLabelButton'
	| 'confluencePageRenameActionCardTitle';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		actionMessage: {
			id: 'ai-mate.message-actions.confluence-page-rename.action-message',
			defaultMessage:
				"Here's the title I suggest renaming to the page {name}. Take a look over it, then select <bold>Rename Page</bold> when you're ready.",
			description:
				'Message text displayed in an action card within the AI conversation interface when the AI suggests renaming a Confluence page. Shown as the main message text in the action card body. The name placeholder will be substituted with the target Confluence page name (e.g., "Project Planning"). The <bold> tags will be rendered as bold text for "Rename Page". The purpose is to present the AI-suggested new page title to the user for review and provide clear instructions on how to proceed with renaming the page.',
		},
		pageSelectorLabel: {
			id: 'ai-mate.message-actions.confluence-page-rename.page-selector-label',
			defaultMessage: 'Page',
			description:
				'Label text displayed above or next to a page selector dropdown in the Confluence page rename action card within the AI conversation interface. Shown as a form field label. The purpose is to identify the page selector control, which allows users to choose which Confluence page will be renamed.',
		},
		titlePlaceholder: {
			id: 'ai-mate.message-actions.confluence-page-rename.title-placeholder',
			defaultMessage: 'Enter new page title',
			description:
				'Placeholder text displayed in a text input field within the Confluence page rename action card in the AI conversation interface. Shown as placeholder text when the input field is empty. The purpose is to guide users on what they should enter in the title input field, prompting them to enter or edit the new page title.',
		},
		titleLabel: {
			id: 'ai-mate.message-actions.confluence-page-rename.title-label',
			defaultMessage: 'New page title',
			description:
				'Label text displayed above or next to a text input field for the new page title in the Confluence page rename action card within the AI conversation interface. Shown as a form field label. The purpose is to identify the title input field, which allows users to enter or edit the new title for the Confluence page.',
		},
		addLabelButton: {
			id: 'ai-mate.message-actions.confluence-page-rename.rename-button',
			defaultMessage: 'Rename page',
			description:
				'Button label displayed on the primary action button in the Confluence page rename action card within the AI conversation interface. Shown as the text on a button at the bottom of the action card. When clicked, it renames the selected Confluence page with the new title. The purpose is to provide a clear call-to-action for users to confirm and execute the page rename.',
		},
		confluencePageRenameActionCardTitle: {
			id: 'ai-mate.message-actions.confluence-page-rename.action-card-title',
			defaultMessage: 'Rename page',
			description:
				'Title text displayed at the top of an action card in the AI conversation interface when the AI suggests renaming a Confluence page. Shown as the card header title. The purpose is to immediately communicate to the user what action the card represents, which is renaming an existing Confluence page.',
		},
	});

export default message;
